import React, { Component } from "react";
import ReactTable from "react-table";

class DataLoggingTable extends Component {
  render() {
    const isAdmin = JSON.parse(localStorage.getItem("role")).some(
      r => r.name === "ROLE_ADMIN"
    );
    let users = this.props.users;
    const columns = [
      {
        Header: "User ID",
        accessor: "data_logging_id",
        width: 70,
        show: false
      },
      { Header: "Full Name", accessor: "name" },
      { Header: "Table changed", accessor: "data_table" },
      { Header: "Email", accessor: "email" },
      { Header: "Time", accessor: "tstamp" }
      
     
    ];
    columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));

    return (
      <ReactTable
        className="-highlight my-1"
        data={users}
        columns={columns}
        filterable
        
        onFilteredChange={filters => {
          console.log(filters);
          localStorage.setItem("logging_filters", JSON.stringify(filters));
        }}
        defaultFiltered={
          JSON.parse(localStorage.getItem("logging_filters")) || []
        }
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (rowInfo && isAdmin) this.props.clicked(rowInfo.row.id);
            }
          };
        }}
      />
    );
  }
}

export default DataLoggingTable;
